import { useMemo } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { compose, map, sort } from 'ramda';

import { equalOrThreeDashes, getCodelistPropById as getTaskName, sortAlphabeticallyBy } from 'utils';
import { joinString } from 'utils/string';

const TaskCells = ({ tasks, keys }) => {
	return keys.map((key, i) => {
		const showAfterNotificationTask = key === 'taskCountBeforeDeadline';
		if (showAfterNotificationTask) {
			return (
				<TableCell align="center" key={i}>
					{joinString('/', [tasks[key], tasks.taskCountAfterNotification])}
				</TableCell>
			);
		} else {
			return (
				<TableCell align="center" key={i}>
					{tasks[key]}
				</TableCell>
			);
		}
	});
};

export const TaskTableRow = ({ personTasks, userIndex, keys, taskTypesCodelist }) => {
	const isEven = userIndex % 2 === 0;

	const personTasksSorted = useMemo(
		() =>
			compose(
				sort(sortAlphabeticallyBy('taskName')),
				map((task) => ({
					...task,
					taskName:
						task.taskTypeId === -1
							? equalOrThreeDashes()
							: getTaskName(task.taskTypeId, taskTypesCodelist, 'shortDescription'),
				})),
			)(personTasks),
		[taskTypesCodelist, personTasks],
	);

	return personTasksSorted.map((pTask, i) => {
		const firstRow = i === 0;
		const taskName =
			pTask.taskTypeId === -1
				? equalOrThreeDashes()
				: getTaskName(pTask.taskTypeId, taskTypesCodelist, 'shortDescription');

		return (
			<TableRow
				sx={{
					backgroundColor: isEven ? 'rgba(0,0,0,0.03)' : null,
				}}
			>
				<TableCell
					sx={{
						opacity: firstRow ? null : '0',
						borderBottom: 'none',
						borderTop: firstRow ? '1px solid rgba(0, 0, 0, 0.12)' : null,
					}}
				>
					{firstRow && (
						<>
							<div>{pTask?.solverName}</div>
							<div>{pTask?.username}</div>
						</>
					)}
				</TableCell>
				<TableCell>{taskName}</TableCell>
				<TaskCells tasks={pTask} keys={keys} />
			</TableRow>
		);
	});
};

TaskTableRow.propTypes = {
	keys: PropTypes.array,
	personTasks: PropTypes.array,
	taskTypesCodelist: PropTypes.array,
	userIndex: PropTypes.number,
};

export default TaskTableRow;
